import type React from 'react';

import { Separator, Spinner, Text } from '@change/ds-core-ui';
import { CheckmarkVerifiedIcon } from '@change/ds-icons';
import { cn } from '@change/ds-utils';

import { Translate } from '@change-corgi/core-react/i18n';
import { ClientRender } from '@change-corgi/core-react/ssr/render';

import { useSignFormStep } from '#src/app/pages/petitionDetails/shared/hooks';

import { SignFormContainer } from '../signFormSunrise';
import { SignatureStatsActiveContainer } from '../stats/signatureStatsSunrise';

const SideUnsignedContainerInner: React.FC<{ signFormStep: number }> = ({ signFormStep }) => {
	return (
		<>
			<div className={cn('flex items-center gap-2', signFormStep === 2 ? 'mb-2' : 'my-4')}>
				{signFormStep === 2 && (
					<CheckmarkVerifiedIcon data-testid="title-checkmark-icon" className="text-icon-information" />
				)}

				<Text variant="heading" as="h2" size="small">
					{signFormStep === 1 ? (
						<Translate value="corgi.petition_gamma.petition_sign.sign_title" />
					) : (
						<Translate value="corgi.petition_gamma.petition_sign.address.verify_title" />
					)}
				</Text>
			</div>

			{signFormStep === 2 && (
				<div className="mb-4">
					<Text variant="body" size="small">
						<Translate value="corgi.petition_gamma.petition_sign.address.disclaimer" />
					</Text>
				</div>
			)}

			<div className="hidden md:block">
				<SignFormContainer dataQa="sign-form-desktop" />
			</div>

			<div className="block md:hidden">
				<Spinner className="mx-auto mt-16 size-6" />
			</div>
		</>
	);
};

export const SideUnsignedContainer: React.FC = () => {
	const { signFormStep } = useSignFormStep();

	return (
		<>
			{signFormStep === 1 && (
				<>
					<div className="mb-4">
						<SignatureStatsActiveContainer />
					</div>
					<Separator />
				</>
			)}

			{/* using programmatic media query to allow lazy loading of the sign form in modal on mobile */}
			{/* Spinner is necessary for SSR */}
			<ClientRender placeholder={<Spinner className="mx-auto mt-16 size-6" />}>
				<SideUnsignedContainerInner signFormStep={signFormStep} />
			</ClientRender>
		</>
	);
};
